
// Re-export from centralized styles for backwards compatibility
export {
  // Typography
  headerStyle,
  detailHeaderStyle,
  textStyle as textStyles,
  dialogTitleStyle as dialogTitleStyles,
  // Containers
  boxContainerStyles,
  alertBoxStyles as boxStyles,
  gridContainerStyles,
  gridToolbarContainerStyles,
  buttonContainerStyles,
  popoverStyles,
  dialogContentWrapperStyles as dialogContentStyles,
  gridStyles,
  filterPanelProps,
  // TextFields
  FormTextField as ContactTextField,
  themedInputStyles as inputStyles,
  // Buttons
  HeaderButton,
  deleteButtonStyles,
  // Info sections
  InfoBox,
  InfoRow,
  InfoLabel,
  InfoValueWrapper,
  InfoValue,
  StyledLinkBlue as StyledLink,
  Underline,
  CityStateZipRow,
  DialogIcon,
  userImageStyles,
  personIconStyles,
  listItemStyle,
} from 'styles/utilities'

/**
 * Dialog styles for Contacts
 */
export const dialogStyles = (theme: { palette: { mode: string } }) => ({
  width: '100%',
  maxWidth: '800px',
  color: theme.palette.mode === 'dark' ? '#fff' : 'black',
  minHeight: '50vh',
  padding: '20px',
  '& .MuiDialogContent-root': {
    width: '100%',
    padding: '20px',
  },
  '& .MuiTextField-root': {
    margin: '10px 0',
  },
})
